window.addEventListener('pplrAppInitiated' , function(e) {
    const sourceElement = document.querySelector('.pplr_atc_form');
    const targetHeader = document.querySelector('.swatch-block-header--custom');
    const disclaimer = document.querySelector('.product-gallery__disclaimer');

    if (sourceElement && targetHeader) {
        targetHeader.classList.remove('disable-block');
    }

    if (disclaimer) {
        disclaimer.classList.remove('disable-text')
    }

    // The app injects .product-personalizer itself, so it usually isn't in the
    // DOM yet at DOMContentLoaded (Safari reliably loses that race).
    observePersonalizerLabels()
})

window.addEventListener('DOMContentLoaded', () => {
    initializeButton()
    observePersonalizerLabels()
});

// Product Personalizer option labels need two fixes, and both depend on the
// label's text — which is a bare text node, so no CSS selector can reach it.
// Tag them here and let td-pdp.css do the hiding.
//
// 1. .td-pplr-label--empty: the app renders the <label> even when the merchant
//    left its text blank. The label has no content height (flexbox drops the
//    whitespace-only text run) but its padding stays, reading as a stray gap
//    above the field.
// 2. .td-pplr-label--duplicate: some options carry an "Add Personalization"
//    label of their own, which repeats the "Add Personalization:" heading the
//    theme already renders in .swatch-block-header--custom.
const PPLR_DUPLICATE_LABEL = /add\s*personali[sz]ation/i

function flagPersonalizerLabels(root) {
    root.querySelectorAll('.pplrlabel').forEach((label) => {
        const text = label.textContent.trim()
        label.classList.toggle('td-pplr-label--empty', text === '')
        label.classList.toggle('td-pplr-label--duplicate', PPLR_DUPLICATE_LABEL.test(text))
    })
}

let personalizerLabelsObserved = false

function observePersonalizerLabels() {
    const widget = document.querySelector('.product-personalizer')
    if (!widget || personalizerLabelsObserved) return
    personalizerLabelsObserved = true

    flagPersonalizerLabels(widget)

    // The app re-renders its options on variant change, so re-check on mutation.
    // childList/characterData only — the class we write is an attribute change,
    // which keeps the observer from retriggering itself.
    let queued = false
    const observer = new MutationObserver(() => {
        if (queued) return
        queued = true
        requestAnimationFrame(() => {
            queued = false
            flagPersonalizerLabels(widget)
        })
    })
    observer.observe(widget, { childList: true, characterData: true, subtree: true })
}

function validateForm() {
    const form = document.querySelector('.shopify-product-form');
    const error_message = document.querySelector('.td-error-message');
    const error_message_list = document.querySelector('.td-error-message-list');
    const invalidControls = form.querySelectorAll('input:invalid, select:invalid, textarea:invalid');

    // Group invalid controls by their data-group attribute
    const groupMap = [];
    if (invalidControls.length > 0) {
        invalidControls.forEach(control => {
            // Only consider controls with a data-group attribute
            const group = control.getAttribute('data-group');
            if (group) {
                if (!groupMap.includes(group)) {
                    groupMap.push(group);
                }
            }
        });
    }

    if (error_message_list) {
        error_message_list.innerHTML = '';
        groupMap.forEach(group => {
            const groupError = document.createElement('li');
            groupError.classList.add('td-error-message-group');
            groupError.textContent = `Please select a ${group}`;
            error_message_list.appendChild(groupError);
        });
    
    }

    if (invalidControls.length > 0) {
        error_message.classList.add("active")
    } else {
        error_message.classList.remove("active")
    }
}

function initializeButton() {
    let atcButton = document.querySelector('.td-sp-button__pdp.add_to_cart')
    if (atcButton) {
        atcButton.addEventListener('click', () => {
            validateForm()
        })
    }
}
/*
  Re-clicking the already-selected colour swatch brings its variant image back.

  The gallery only moves in response to window.selectCallback, which runs off the
  radio's `change` event. Re-clicking a radio that is already checked fires no
  `change`, so once a shopper swipes the gallery away from their variant's image
  there is no way back to it - the swatch looks inert. Re-triggering `change` on
  the matching .single-option-selector re-runs the normal variant path, which
  scrolls Flickity back to that variant's cell.

  `change` still handles the case where a *different* swatch is picked, so this
  only fires when the clicked radio was already checked before the click. The
  pointerdown listener captures that, because by click time the browser has
  already set .checked.
*/
(function tdVariantImageRecall() {
  var SWATCH = '.swatch';
  var armedRadio = null;

  function radioFor(target) {
    if (!target || !target.closest) return null;
    var hit = target.closest(SWATCH + ' input[type="radio"], ' + SWATCH + ' label, ' + SWATCH + ' li');
    if (!hit) return null;
    if (hit.matches('input[type="radio"]')) return hit;
    var forId = hit.getAttribute && hit.getAttribute('for');
    if (forId) {
      var byFor = document.getElementById(forId);
      if (byFor) return byFor;
    }
    return hit.querySelector('input[type="radio"]');
  }

  // Capture in the capture phase, before the browser toggles .checked.
  document.addEventListener('pointerdown', function (event) {
    var radio = radioFor(event.target);
    armedRadio = radio && radio.checked ? radio : null;
  }, true);

  document.addEventListener('click', function (event) {
    var radio = radioFor(event.target);
    if (!radio || radio !== armedRadio) return;
    armedRadio = null;

    var form = radio.closest('form');
    var swatch = radio.closest(SWATCH);
    if (!form || !swatch || !window.jQuery) return;

    var optionIndex = parseInt(swatch.getAttribute('data-option-index'), 10);
    if (isNaN(optionIndex)) return;

    var selector = form.querySelectorAll('.single-option-selector')[optionIndex];
    if (selector) window.jQuery(selector).trigger('change');
  });
})();
